/* Fransk katalog for locale-manual-preview-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'manualPreview.reset': 'Réinitialiser',
  'manualPreview.title': 'Comptabilisation',
  'manualPreview.details': 'Détails',
  'manualPreview.summary': 'Synthèse par compte',
  'manualPreview.date': 'Date',
  'manualPreview.account': 'Compte',
  'manualPreview.vat': 'Code TVA',
  'manualPreview.before': 'Solde avant',
  'manualPreview.amount': 'Montant',
  'manualPreview.after': 'Solde après',
  'manualPreview.debit': 'Débit',
  'manualPreview.credit': 'Crédit',
  'manualPreview.net': 'Variation nette',
  'manualPreview.warning.balances': 'Les soldes ne sont pas disponibles dans les données comptables. Les écritures sont affichées sans solde avant et après.',
  'manualPreview.warning.editing': 'En cas de correction, l\'écriture de remplacement est affichée ici. Les soldes avant et après ne sont pas affichés, car la correction peut aussi contrepasser un justificatif antérieur.',
  'manualPreview.warning.years': 'Les écritures s\'étendent sur plusieurs années civiles. Les lignes d\'écriture sont affichées, mais les soldes avant et après ne sont pas calculés d\'une année à l\'autre.',
  'manualPreview.warning.country': 'L\'aperçu ne dispose pas du pays comptable ou ne prend pas en charge le traitement de TVA choisi pour ce pays.',
});
